import { ActionReducerMap } from '@ngrx/store';

import {
    authenticationReducer,
    oauthReducer,
    SearchOptionsReducer,
    selectionReducer,
    toastReducer,
    userPreferencesReducer,
    userReducer,
    verifierReducer,
    ViewOptionsReducer
} from '@mediahaven/shared';
import { PortalState } from '../../state/state';
import { RecordsReducer } from './records/records.reducer';

export const rootReducer: ActionReducerMap<PortalState> = {
    viewOptions: ViewOptionsReducer,
    searchOptions: SearchOptionsReducer,
    records: RecordsReducer,
    toast: toastReducer,
    userPreferences: userPreferencesReducer,
    authentication: authenticationReducer,
    oauth: oauthReducer,
    user: userReducer,
    selection: selectionReducer,
    verifier: verifierReducer
};
